import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from "@angular/core";
import {OnDestroy$} from "@pdtec/ngx-observable-lifecycle";
import {Subject} from "rxjs";

@Component({
    selector: 'app-filters-skeleton',
    templateUrl: './filters-skeleton.component.html',
    styleUrls: ['./filters-skeleton.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class FiltersSkeletonComponent extends OnDestroy$ implements OnInit, OnDestroy{
    private destroy$ = new Subject<void>();

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
